export default "__VITE_ASSET__DLoEmURN__"